<template>
  <div>

    <div class="draw-warp" v-if="isShowLuckying">
      <span class="icontemp stemp-close close" @click="close()"></span>
      <div class="header">
        <span class="name">{{ luckyName }}</span>
        <span>即将揭晓</span>
      </div>
      <div class="draw-img">
        <div class="draw-img-border">
          <img
              :src="luckyImageUrl ? luckyImageUrl : luckyDrawDefImg"
              alt=""
              class="draw-img-img"
          />
        </div>
      </div>
      <div class="draw-name">{{ awardName }}</div>
      <div class="draw-content">
        <div class="drawing-tips">抽奖进行中</div>
        <div class="drawing-img">
          <img src="../../assets/images/roll.gif" alt=""/>
        </div>
      </div>
    </div>
    <div class="draw-warp" v-if="isShowLuckyList">
      <span class="icontemp stemp-close close" @click="close()"></span>
      <div class="header">
        <span class="name">{{ luckyName }}</span>
        <span>中奖名单</span>
      </div>
      <div class="draw-img">
        <div class="draw-img-border">
          <img
              :src="luckyImageUrl ? luckyImageUrl : luckyDrawDefImg"
              alt=""
              class="draw-img-img"
          />
        </div>
      </div>
      <div class="draw-name">{{ awardName }}</div>
      <div class="draw-content">
        <div class="drawing-tips">
          {{ isWinner ? "恭喜您中奖了" : "很遗憾，您没中奖" }}
        </div>
        <!--<div class="drawing-img">-->
        <!--<img src="../../assets/images/roll.gif" alt="">-->
        <!--</div>-->

        <div class="draw-winning-list">
          <GeminiScrollbar ref="scroll" :autoshow="true">
            <div class="list-item">
              <div
                  class="name"
                  :style="{
                  margin: winnerList.length > 1 ? '' : 'auto',
                  width: winnerList.length > 1 ? '50%' : '100%',
                  'text-align': winnerList.length > 1 ? '' : 'center'
                }"
                  v-for="(p, i) in winnerList"
                  :key="i"
              >
                {{ p.showName }}
              </div>
            </div>
          </GeminiScrollbar>
        </div>
      </div>
    </div>
    <div class="draw-warp" v-if="isShowWinningList">
      <span class="icontemp stemp-close close" @click="close()"></span>
      <div class="header header-list">
        <span>中奖名单</span>
      </div>
      <GeminiScrollbar ref="scroll" :autoshow="true" class="lottery-scroll-bar">
        <div class="all-draw">
          <div class="draw-item" v-for="(l, i) in luckyList" :key="i">
            <div class="draw-list-name">{{ l.name }}</div>
            <div class="draw-list-content">
              <div class="draw-img">
                <img :src="l.image ? l.image : luckyDrawDefImg" alt=""/>
              </div>
              <div class="draw-s-name">{{ l.awardName }}</div>
              <div class="draw-winn-list">
                <div
                    class="name"
                    :style="{ width: l.members.length > 1 ? '50%' : '100%' }"
                    v-for="(w, i) in l.members"
                    :key="i"
                >
                  {{ w.showName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </GeminiScrollbar>
    </div>
    <div class="draw-warp-zijie" v-if="isShowResult">
      <div class="close" @click="isShowResult = false">
        <img src="../../assets/images/lottery-close1.png" alt="">
      </div>
      <div v-show="isWinner" class="draw-in-box">
        <img src="../../assets/images/lottery-in.png" alt="">
      </div>
      <div v-show="isWinner" class="draw-tips">
        恭喜您已中奖
      </div>
      <div v-show="isWinner" class="draw-form">
        <div class="item">
          <span class="lable">姓&nbsp;&nbsp;&nbsp;名</span>
          <input v-model="drawName" :disabled="isAction" type="text">
        </div>
        <div class="item">
          <span class="lable">电&nbsp;&nbsp;&nbsp;话</span>
          <input v-model="drawMobile" type="text" :disabled="isAction">
        </div>
        <div class="item">
          <span class="lable">邮寄地址</span>
          <input v-model="drawAddress" type="text" :disabled="isAction">
        </div>
      </div>
      <div v-show="isWinner" :class="isSubmitting || isAction ? 'disable':''" class="draw-button-box"
           @click="actionDrawCustomForm">
        <img src="../../assets/images/form-button.png" alt="">
        <span>提 交</span>
      </div>
      <div v-show="!isWinner" class="draw-out-box">
        <img src="../../assets/images/lottery-out.png" alt="">
      </div>
      <div v-show="!isWinner" class="draw-tips">
        谢谢参与
      </div>
      <div v-show="!isWinner" class="draw-sub-tips">
        很遗憾，您没有中奖
      </div>
      <div v-show="!isWinner" class="draw-winners-list">
        <div class="winner-list-title">
          中奖名单
        </div>
        <div class="winner-content-lists">
          <div class="winner-list-item" v-for="(item,index) in winnerList" :key="index">
              {{item.mobile}}
          </div>
        </div>
      </div>
    </div>
    <div class="draw-warp-zijie-box"  v-if="isDrawnPrize">
      <div class="draw-warp-zijie-box-text">
        本轮抽奖参与成功，即将开奖敬请关注!
      </div>
    </div>
  </div>
</template>

<script>
//  import { $subscriber } from "fire-wind-water";
//  import ws from "../../services/webinar";
import {buildLotteryData, buildTableMethod, mounted} from "../../common/lottery";

export default {
  name: "Lottery",
  data() {
    return buildLotteryData({});
  },
  created() {
  },
  methods: buildTableMethod({}),
  //    close() {
  //      this.isShowLuckying = false;
  //      this.isShowLuckyList = false;
  //      this.isShowWinningList = false;
  //    },
  //    showLuckying() {
  //      this.isShowLuckying = true;
  //    },
  //    showLuckyList() {
  //      this.isShowLuckyList = true;
  //    },
  //    encryptUserInfo(val, type) {
  //
  //      var encryptor = {
  //        email: function (val) {
  //          var prefix = val.replace(/^(.*)@.*$/, '$1');
  //          if (prefix.length < 5) {
  //            return val.replace(/^[^@]*@(.*)$/, '****@$1');
  //          }
  //          return val.replace(/^(\w{2}).*(\w{2})@(.*)$/, '$1****$2@$3');
  //        },
  //        qq: function (val) {
  //          if (val.length < 4) {
  //            return val[0] + '****';
  //          }
  //          return val.replace(/^(\d{2})\d+(\d{2})$/, '$1****$2');
  //        },
  //        mobile: function (val) {
  //          if (val.length !== 11) {
  //            return val.replace(/^(.*)([\w]{4})$/, '****$2');
  //          }
  //          return val.replace(/^(\w{3})\w{4}(\w{4})$/, '$1****$2');
  //        }
  //      };
  //      if (Object.prototype.hasOwnProperty.call(encryptor, type)) {
  //        if (typeof val !== 'string') {
  //          return val;
  //        }
  //
  //        return encryptor[type](val);
  //      }
  //
  //      return val;
  //    },
  //
  //    //获取显示名
  //    getShowName(userInfo, index) {
  //      let self = this;
  //      var infoList = ['mobile', 'email', 'qq', 'nickName'];
  //      if (!index) {
  //        index = 0;
  //      }
  //      var userName = userInfo['userName'] || userInfo['realName'] || '';
  //      if (!userName.length) {
  //        userName = '匿名';
  //      }
  //      var info = infoList[index];
  //      if (userInfo[info]) {
  //        return userName + self.encryptUserInfo(userInfo[info], info);
  //      } else {
  //        if (index < infoList.length) {
  //          index++;
  //          return self.getShowName(userInfo, index);
  //        } else {
  //          return userName;
  //        }
  //      }
  //    },
  //    getLuckyDrawRoster(){
  //      var self = this;
  //      let params = {
  //        tenantId:self.webinarInfo.tenantId,
  //        instanceId:self.webinarInfo.instanceId
  //      }
  //      ws.getLotteryRecord(params).subscribe((data)=>{
  //        if(data.result == 0) {
  //          let list = data.content;
  //          for(let i in list){
  //            self.winnerListHandler(list[i].members);
  //          }
  //          self.luckyList = list;
  //          self.isShowWinningList = true;
  //        }
  //      })
  //    },
  //    winnerListHandler(winnerList){
  //      let self = this;
  //      for(let i in winnerList) {
  //        let winner = winnerList[i];
  //        winner.showName = self.getShowName(winner);
  //        winner.name = winner.name || self.encryptUserInfo(winner.mobile, 'mobile') || self.encryptUserInfo(winner.email, 'email');
  //        if(winner.userid == self.user.applicantId){
  //          self.isWinner  = true;
  //        }
  //      }
  //      return winnerList;
  //    }
  mounted() {
    //    let self = this;
    //    $subscriber.subscribe("webinarInfo", data => {
    //      console.log('webinarInfo：',data);
    //      self.webinarInfo = data;
    //    });
    //    $subscriber.subscribe("userInfo", data => {
    //      console.log('用户信息：',data);
    //      self.user = data;
    //    });
    //    $subscriber.subscribe('onLuckyDraw',(data)=>{
    //      console.log(data);
    //      self.luckyName = data.name;
    //      self.isShowLuckying = true;
    //    });
    //    $subscriber.subscribe('onLuckyDrawEnd',(data)=>{
    //      self.winnerList = data.data.members;
    //      self.luckyName = data.name;
    //      self.winnerListHandler(self.winnerList);
    ////      for(let i in self.winnerList) {
    ////        let winner = self.winnerList[i];
    ////        winner.showName = self.getShowName(winner);
    ////        winner.name = winner.name || self.encryptUserInfo(winner.mobile, 'mobile') || self.encryptUserInfo(winner.email, 'email');
    ////        if(winner.userid == self.user.applicantId){
    ////          self.isWinner  = true;
    ////        }
    ////      }
    //      self.isShowLuckying = false;
    //      self.showLuckyList();
    //    })
    //    $subscriber.subscribe('getLuckyDrawRoster',()=>{
    //      self.getLuckyDrawRoster();
    //    })

    return mounted(this);
  }
};
</script>

<style scoped></style>
